import { apiGet } from './client';

export interface OnboardingStatus {
  sessionId: string;
  status: 'in_progress' | 'completed' | 'abandoned';
  currentStep: number;
  websiteId: string | null;
  businessName: string | null;
}

/**
 * Looks up the customer's onboarding session via the public orchestrator endpoint.
 * Returns null when there's no session or the lookup fails — callers treat that as
 * "nothing to resume" (i.e. don't redirect into the wizard).
 */
export async function getOnboardingStatus(
  customerId: string
): Promise<OnboardingStatus | null> {
  try {
    return await apiGet<OnboardingStatus>(`/api/onboarding/by-customer/${customerId}`);
  } catch {
    return null;
  }
}
